module.exports = {"140423100":"古韩镇","140423101":"王桥镇","140423102":"侯堡镇","140423103":"夏店镇","140423104":"虒亭镇","140423105":"西营镇","140423106":"王村镇","140423107":"下良镇","140423200":"善福乡","140423201":"北底乡","140423202":"上马乡","140423400":"富阳工业园区","140423402":"襄垣经济技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140423.json
// module id = 297
// module chunks = 0